// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2SyHB","rootCenter":"LoadMoreObserver_rootCenter__2MTqf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2KvEn"};